import React from 'react';

const ContactSection = () => {
  return (
    <section className="py-20 px-6 max-w-7xl mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
        
        {/* Left Column: Contact Information */}
        <div>
          <span className="text-electric-green font-bold text-sm uppercase tracking-widest mb-2 block">Get in Touch</span>
          <h2 className="text-4xl font-bold text-white mb-6">Let's Build Something Awesome Together</h2>
          <p className="text-gray-400 mb-12 leading-relaxed">
            Ready to start your digital transformation? Fill out the form and our team of IT experts will get back to you within 24 hours.
          </p>

          <div className="space-y-8">
            {/* Address */}
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-[#1A1F29] border border-white/10 flex items-center justify-center flex-shrink-0 text-electric-green shadow-[0_0_15px_rgba(57,255,20,0.1)]">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.243-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
              </div>
              <div>
                <h4 className="text-white font-bold mb-1">Our Location</h4>
                <p className="text-gray-400 text-sm">Austin, Texas 78701<br/>États-Unis</p>
              </div>
            </div>

            {/* Email */}
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-[#1A1F29] border border-white/10 flex items-center justify-center flex-shrink-0 text-electric-green shadow-[0_0_15px_rgba(57,255,20,0.1)]">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
              </div>
              <div>
                <h4 className="text-white font-bold mb-1">Email Us</h4>
                <p className="text-gray-400 text-sm">anesserdev@gmail.com</p>
              </div>
            </div>

            {/* Phone */}
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-[#1A1F29] border border-white/10 flex items-center justify-center flex-shrink-0 text-electric-green shadow-[0_0_15px_rgba(57,255,20,0.1)]">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
              </div>
              <div>
                <h4 className="text-white font-bold mb-1">Call Us</h4>
                <p className="text-gray-400 text-sm">+1 3026623424</p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column: Glassmorphism Form */}
        <div className="relative">
          {/* Subtle Glow */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-72 h-72 bg-electric-green/10 rounded-full blur-[100px] pointer-events-none"></div>
          
          <form className="relative bg-[#1A1F29]/60 backdrop-blur-xl border border-white/10 rounded-2xl p-8 md:p-10 shadow-2xl">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-400 mb-2">First Name</label>
                <input type="text" className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white placeholder-gray-600 focus:outline-none focus:border-electric-green focus:ring-1 focus:ring-electric-green transition-all" placeholder="John" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-400 mb-2">Last Name</label>
                <input type="text" className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white placeholder-gray-600 focus:outline-none focus:border-electric-green focus:ring-1 focus:ring-electric-green transition-all" placeholder="Doe" />
              </div>
            </div>
            
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-400 mb-2">Email Address</label>
              <input type="email" className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white placeholder-gray-600 focus:outline-none focus:border-electric-green focus:ring-1 focus:ring-electric-green transition-all" placeholder="john@example.com" />
            </div>

            <div className="mb-8">
              <label className="block text-sm font-medium text-gray-400 mb-2">Your Message</label>
              <textarea rows="4" className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white placeholder-gray-600 focus:outline-none focus:border-electric-green focus:ring-1 focus:ring-electric-green transition-all resize-none" placeholder="How can we help you?"></textarea>
            </div>

            <button type="button" className="w-full bg-electric-green text-royal-navy font-bold text-lg py-4 rounded-lg hover:shadow-[0_0_20px_rgba(57,255,20,0.4)] transition-all">
              Send Message
            </button>
          </form>
        </div>

      </div>
    </section>
  );
};

export default ContactSection;